import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import { ErrorFallback } from "./ErrorBoundary";

export function RouterErrorBoundary() {
  const error = useRouteError();
  
  // Handle route errors differently
  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-primary mb-4">404</h1>
            <p className="text-secondary mb-6">Page not found</p>
            <a href="/" className="text-primary hover:underline">
              Go back to dashboard
            </a>
          </div>
        </div>
      );
    }
    
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-primary mb-4">{error.status}</h1>
          <p className="text-secondary mb-6">{error.statusText || "An error occurred"}</p>
          <a href="/" className="text-primary hover:underline">
            Go back to dashboard
          </a>
        </div>
      </div>
    );
  }
  
  // For other errors, use the standard error fallback
  if (error instanceof Error) {
    return <ErrorFallback error={error} />;
  }
  
  // Fallback for unknown errors
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-primary mb-4">Error</h1>
        <p className="text-secondary mb-6">An unexpected error occurred</p>
        <a href="/" className="text-primary hover:underline">
          Go back to dashboard
        </a>
      </div>
    </div>
  );
}